module.exports = __webpack_public_path__ + "files/b73f1eaffe1fdfc8cd8d8f401b4cc430.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-italic-webfont.woff2
 ** module id = 993
 ** module chunks = 0
 **/